module.exports = __webpack_public_path__ + "static/media/language-it.03a67880.svg";